(function () {
  function init() {
    var bar = document.querySelector('[data-pd-sticky]');
    if (!bar || bar.dataset.pdReady) return;
    var main = document.querySelector('[id^="MainProduct-"]');
    var mainButton = main ? main.querySelector('.product-form__submit') : null;
    if (!mainButton) return;
    bar.dataset.pdReady = 'true';

    var stickyButton = bar.querySelector('[data-pd-sticky-button]');
    var stickyPrice = bar.querySelector('[data-pd-sticky-price]');
    var priceBox = main.querySelector('[id^="price-"]');

    function show(visible) {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      stickyButton.tabIndex = visible ? 0 : -1;
      document.body.classList.toggle('pd-has-sticky', visible);
    }

    var io = null;
    function watch(btn) {
      if (!('IntersectionObserver' in window)) return;
      if (io) io.disconnect();
      io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        show(!e.isIntersecting && e.boundingClientRect.top < 0);
      });
      io.observe(btn);
    }

    function syncState() {
      var fresh = main.querySelector('.product-form__submit');
      if (fresh && fresh !== mainButton) {
        mainButton = fresh;
        watch(mainButton);
      }
      var disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
      stickyButton.disabled = disabled;
      if (priceBox && stickyPrice) {
        var price = priceBox.querySelector('.price');
        var current = null;
        if (price && price.classList.contains('price--on-sale')) {
          current = price.querySelector('.price__sale .price-item--sale');
        } else if (price) {
          current = price.querySelector('.price__regular .price-item--regular');
        }
        if (current && current.textContent.trim()) stickyPrice.textContent = current.textContent.trim();
      }
    }

    watch(mainButton);

    new MutationObserver(syncState).observe(main, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
    syncState();

    stickyButton.addEventListener('click', function () {
      var current = main.querySelector('.product-form__submit');
      if (current && !current.disabled) current.click();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
